import { Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './globals.css';

import App from './App';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthProvider';

import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import LoadingScreen from './components/portal/feedback/LoadingScreen';

import ReactGA from "react-ga4";
import ErrorBoundaryCOMPONENT from './components/portal/error/ErrorBoundary';
import { ErrorBoundary } from "react-error-boundary";
import { Provider } from 'react-redux';
import { store } from './redux';

const TRACKING_ID = 'G-XJMFLX7E8C'
ReactGA.initialize(TRACKING_ID)

require('./i18n')

export const queryclient = new QueryClient()

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const basename = process.env.REACT_APP_BASE_PATH ?? document.querySelector('base')?.getAttribute('href') ?? '/'

root.render(
    <QueryClientProvider client={queryclient}>
      <Provider store={store}>

        <Suspense fallback={<LoadingScreen />}>
          <AuthProvider>
            <ErrorBoundary fallback={<ErrorBoundaryCOMPONENT />}>
              <BrowserRouter basename={basename}>
                  <Routes>
                    <Route path="/*" element={<App />} />
                  </Routes>
              </BrowserRouter>
            </ErrorBoundary>
          </AuthProvider>
        </Suspense>

      </Provider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
);
